import styled from 'styled-components/macro'
export const DoorsAndWindowsLeftWrapper = styled.div``